<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
export default {
    name: 'signupVerification',
    components: { Page, PageIntro },
    data() {
        return {
            verificationCode: '',
            description: this.$t('views.SuccessAanmelding.description')
        }
    },
    methods: {
        GotoHome() {
            this.$router.push({ name: 'Home' });
        }
    },
    mounted() {
        if (this.$store.state.aanMeldingVerify !== true) {
            this.$router.push({ name: 'Home' });
        }
    }
}
</script>

<template>
 <Page :displayBackButton=false>
     <div class="section">
        <PageIntro :head="$t('views.SuccessAanmelding.pageHeader')" :intro="$t('views.SuccessAanmelding.pageIntro')"/>
        <div class="section-block">
            <span v-html=" $t('views.SuccessAanmelding.description') "></span>
            <div class="submit" style="margin-bottom: 160px;">
                <button class="buttonAanmelding" @click="GotoHome">Home</button>
            </div>
        </div>
    </div>
</Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";
@import "@/styles/input";
@import "@/styles/typography";
@import "@/styles/aanmelding";
.ProvideTestCode {

    .UserConsent {
        margin-bottom: $length-s;
    }

    .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }
}
</style>
